var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--text",style:(_vm.messageColors)},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.messageText)}}),_vm._v(" "),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ebfe60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbot/TextMessage.vue
// module id = null
// module chunks = 